import {
    INITIATE_APPLICATION,
    FETCH_APPLICATIONS,
    GET_SCHEMA,
    UPDATE_SCHEMA,
    SIGNATORY_REVIEW,
    GET_APPLICATION,
    FETCH_REVIEWED_APPLICATIONS,
    CLEAR_APPLICATION_DETAILS,
    GET_ACCESSAREAS,
    BADGE_REAPPLY,
    INITIATE_BADGE_DELETE,
    REJECT_BADGE,
    RENEWAL_APPLICATION,
    EDIT_APPLICATION
  } from './types';

  const BACKEND_API = 'BACKEND_API';

  export const initiateApplication = data => ({
    type: BACKEND_API,
    payload: {
        method: 'POST',
        data,
      url: '/portal_badging/',
      ...INITIATE_APPLICATION
    }
  });


  export const getAccessAreas=() => ({
    type: BACKEND_API,
    payload: {
      method: 'GET',
      url: '/portal_badging/get_access_areas/',
      ...GET_ACCESSAREAS
    }
  });

  export const rejectBadge = (id, data) => ({
    type: BACKEND_API,
    payload: {
      method: 'POST',
      data,
      url: `/portal_badging/${id}/reject_badge/`,
      ...REJECT_BADGE
    }
  });

  export const fetchApplications = () => ({
    type: BACKEND_API,
    payload: {
        method: 'GET',
      url: '/portal_badging/badge_list/',
      ...FETCH_APPLICATIONS
    }
  });

  export const fetchReviewedApplications = () => ({
    type: BACKEND_API,
    payload: {
        method: 'GET',
      url: '/portal_badging/badge_reviewed_list/',
      ...FETCH_REVIEWED_APPLICATIONS
    }
  });

  export const updateSchema = data => ({
    type: BACKEND_API,
    payload: {
        method: 'POST',
        data,
      url: '/badging/update_schema/',
      ...UPDATE_SCHEMA
    }
  });

  export const getSchema = () => ({
    type: BACKEND_API,
    payload: {
        method: 'GET',
      url: '/portal_badging/get_schema/',
      ...GET_SCHEMA
    }
  });

  export const signitoryReview = (id, data) => ({
    type: BACKEND_API,
    payload: {
        method: 'POST',
        data,
      url: `/portal_badging/${id}/signatory_review/`,
      ...SIGNATORY_REVIEW
    }
  });

  export const getApplication = id => ({
    type: BACKEND_API,
    payload: {
        method: 'GET',
      url: `/portal_badging/${id}/`,
      ...GET_APPLICATION
    }
  });

  export const editApplication = (id, data) => ({
    type: BACKEND_API,
    payload: {
        method: 'PATCH',
        data,
      url: `/portal_badging/${id}/`,
      ...EDIT_APPLICATION
    }
  });
  export const badgeReapply = (id, data) => ({
    type: BACKEND_API,
    payload: {
        method: 'patch',
        data,
      url: `/portal_badging/${id}/`,
      ...BADGE_REAPPLY
    }
  });

  export const initiateBadgeDelete = id => ({
    type: BACKEND_API,
    payload: {
      method: 'delete',
      url: `/portal_badging/${id}/`,
    ...INITIATE_BADGE_DELETE
    }
  });

  export const renewApplication = (id, data) => ({
    type: BACKEND_API,
    payload: {
        method: 'POST',
        data,
      url: `/portal_badging/${id}/renew_expired_portal_badge/`,
      ...RENEWAL_APPLICATION
    }
  });

  export const clearApplicationDetails = () => ({
    type: CLEAR_APPLICATION_DETAILS
  });
